import { AnimatePresence } from 'motion/react';
import React, { FC, ReactElement } from 'react';

import BannerBaseWithAnimation, {
  BannerBaseProps,
} from './BannerBaseWithAnimation';

export interface NotificationProps extends BannerBaseProps {
  isOpen?: boolean;
  icon?: ReactElement;
  withMarginBottom?: boolean;
  isBold?: boolean;
}

const Banner: FC<React.PropsWithChildren<NotificationProps>> = ({
  onClose = undefined,
  hollow = false,
  isOpen = true,
  hasIcon = true,
  children,
  isFluid = false,
  notificationType,
  icon,
  withMarginBottom,
  isBold = false,
  dataTestId,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <BannerBaseWithAnimation
          notificationType={notificationType}
          onClose={onClose}
          hollow={hollow}
          hasIcon={hasIcon}
          isFluid={isFluid}
          icon={icon}
          withMarginBottom={withMarginBottom}
          isBold={isBold}
          dataTestId={dataTestId}
        >
          {children}
        </BannerBaseWithAnimation>
      )}
    </AnimatePresence>
  );
};

export default React.memo(Banner);
